import type { Dispatch } from 'redux';
import { connect } from '@atlassian/jira-react-redux';
import { getProjectIdSelector, getProjectTypeSelector } from '../state/context/selectors';
import {
	type ProjectDetailsEntitiesAction as Action,
	reloadOnRefresh,
} from '../state/entities/actions';
import { hasFetchDataErrorSelector, isFetchingDataSelector } from '../state/entities/selectors';
import type { AppState } from '../state/types';
import {
	flagsSelector,
	isArchiveProjectModalOpenSelector,
	isAvatarPickerDialogOpenSelector,
	isDeleteProjectModalOpenSelector,
	isFormDirtySelector,
	isTrashProjectModalOpenSelector,
} from '../state/ui/selectors';
import AvatarPickerDialog from './avatar-picker-dialog';
import Flags from './flags';
import Form from './form';
import Header from './header';
import ArchiveProject from './modal-dialogs/archive-project';
import DeleteProject from './modal-dialogs/delete-project';
import SoftDeleteProject from './modal-dialogs/soft-delete-project';
import Details from './view';

const mapStateToProps = (state: AppState) => ({
	flags: flagsSelector(state),
	isAvatarPickerDialogOpen: isAvatarPickerDialogOpenSelector(state),
	isDeleteProjectModalOpen: isDeleteProjectModalOpenSelector(state),
	isTrashProjectModalOpen: isTrashProjectModalOpenSelector(state),
	isArchiveProjectModalOpen: isArchiveProjectModalOpenSelector(state),
	isFetchingData: isFetchingDataSelector(state),
	hasFetchDataError: hasFetchDataErrorSelector(state),
	isFormDirty: isFormDirtySelector(state),
	FormComponent: Form,
	AvatarPickerDialogComponent: AvatarPickerDialog,
	FlagsComponent: Flags,
	DeleteProjectModalComponent: DeleteProject,
	SoftDeleteProjectModalComponent: SoftDeleteProject,
	ArchiveProjectModalComponent: ArchiveProject,
	HeaderComponent: Header,
	projectId: getProjectIdSelector(state),
	projectType: getProjectTypeSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
	onRefresh: () => {
		dispatch(reloadOnRefresh());
	},
});

export default connect(mapStateToProps, mapDispatchToProps)(Details);
